const pms_exit_strategy = [
  {
    value: "3_months",
    name: "3 Months",
  },
  {
    value: "6_months",
    name: "6 Months",
  },
  {
    value: "9_months",
    name: "9 Months",
  },
  {
    value: "12_months",
    name: "12 Months",
  },
  {
    value: "2_years",
    name: "2 Years",
  },
  {
    value: "3_years",
    name: "3 Years",
  },
  {
    value: "5_years",
    name: "5 Years",
  },
];

export default pms_exit_strategy;



// WEBPACK FOOTER //
// ./src/constants/pms_exit_strategy.js